import { useEffect, useState } from "react";
import axios, { AxiosRequestConfig } from "axios";

// USAGE
/*
  const { data, isLoading, error, reFetch } = useQuery("https://dummyjson.com/products");

  useEffect(() => {
    if (data) console.log("data", data);
    if (error) console.log("error", error);
    if (isLoading) console.log("loading", isLoading);
  }, [data, error, isLoading]);

  return (
    <button onClick={reFetch()}>Refetch</button>
  )
*/

type ResponseType = {
  data: {
    [key: string]: any;
  } | null;
  isLoading: boolean;
  error: any;
  reFetch: () => void;
};

const useQuery = (
  url: string,
  options?: AxiosRequestConfig<any>,
  skip?: boolean
): ResponseType => {
  const [responseData, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    await axios({
      url,
      method: "GET",
      ...(options && { options }),
    })
      .then((response) => {
        if (response.data) setData(response.data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!responseData && !isLoading && !skip) getData();
  }, [isLoading, responseData, skip]);

  return {
    data: responseData,
    isLoading,
    error,
    reFetch: () => setData(null),
  };
};

export default useQuery;
